import HttpClient from "../../clients/HttpClient";
import { UserGroup, UserGroupTableRow } from "../../models/UserGroup";

export default class UserGroupService {
  static httpClient: HttpClient = HttpClient.getInstance("backend", process.env.REACT_APP_API_URL);

  public static async list(params = {}): Promise<Array<UserGroup>> {
    return this.httpClient.get("/user_groups", params).then((res) => {
      return res.data.map((row) => new UserGroup(row));
    });
  }

  public static async getUserGroup(id): Promise<UserGroup> {
    return this.httpClient.get(`/user_groups/${id}`).then((res) => {
      return new UserGroup(res.data);
    });
  }

  public static async addUserGroup(data): Promise<UserGroup> {
    return this.httpClient.post(`/user_groups`, data).then((res) => {
      return new UserGroup(res.data);
    });
  }

  public static async editUserGroup(id, data): Promise<UserGroup> {
    return this.httpClient.put(`/user_groups`, data).then((res) => {
      return new UserGroup(res.data);
    });
  }

  public static async deleteUserGroup(id): Promise<boolean> {
    return this.httpClient.delete(`/user_groups/${id}`, null).then((res) => {
      return true;
    });
  }

  public static async listUserGroupsOnAccount(accountId): Promise<Array<UserGroup>> {
    return this.httpClient.get("/accounts/" + accountId + "/user_groups").then((res) => {
      return res.data.map((row) => new UserGroup(row));
    });
  }

  public static async listUserGroupsOnAccountWithContractsAndMembers(accountId): Promise<Array<UserGroupTableRow>> {
    return this.httpClient.get("/accounts/" + accountId + "/user_groups_with_contracts_and_members").then((res) => {
      return res.data.map((row) => new UserGroupTableRow(row));
    });
  }
}

